var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left mr-1"},[_c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-times-circle-o fa-lg icon-button",attrs:{"title":"Descomprometer"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarDescomprometer()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }